<template>
  <div class="px-3 page-title">
    <p v-show="activeTab != 1">
      {{ clientConfig.content.general.modellerName }}
    </p>
    <h1 tabindex="0">
      {{ title || clientConfig.content.general.modellerName }}
    </h1>
  </div>
</template>

<script>
import clientConfig from "/src/config/foresters-financial";
import { mapGetters } from "vuex";

export default {
  name: "HeaderFragment",

  props: {
    title: String,
  },

  data() {
    return {
      clientConfig,
    };
  },
  computed: {
    ...mapGetters(["activeTab"]),
  },
};
</script>
